<template>
<svg viewBox="0 0 48 48" :fill="useCurrentColor ? 'currentColor' : '#000'" :class="[`${prefix}-icon`, `${prefix}-icon-case`]" width="1em" height="1em" v-bind="$attrs"><path fill-rule="evenodd" clip-rule="evenodd" d="M38.27 4c2.002 0 3.622 1.585 3.725 3.563l.005.199v11.281h-4V8H10v33h6.278v4H9.73c-2.002 0-3.622-1.585-3.725-3.563L6 41.238V7.762C6 5.759 7.556 4.11 9.53 4.005L9.73 4h28.54zm-4.807 16.352c.387.2.703.516.903.903l2.816 5.457 6.322.879a2.1 2.1 0 011.143 3.616l-4.517 4.212 1.063 5.93a2.1 2.1 0 01-3.01 2.247L32.5 40.74l-5.682 2.857a2.1 2.1 0 01-3.01-2.247l1.063-5.93-4.518-4.212a2.1 2.1 0 011.143-3.616l6.322-.879 2.816-5.457a2.1 2.1 0 012.829-.903zm-3.04 10.037l2.077-4.027 2.078 4.027 4.422.614-3.192 2.977.777 4.336L32.5 36.26l-4.085 2.055.777-4.336L26 31.003l4.422-.614zM21 20a1 1 0 011 1v2a1 1 0 01-1 1h-6a1 1 0 01-1-1v-2a1 1 0 011-1h6zm9-7a1 1 0 00-1-1H15a1 1 0 00-1 1v2a1 1 0 001 1h14a1 1 0 001-1v-2z"/></svg>
</template>
<script>

export default {
  name: 'IconCase',
  props: {
    prefix: {
        type: String,
        default: 'arco',
    },
    useCurrentColor: {
        type: Boolean,
        default: true,
    },
  },
};
</script>
